import apiClient from '../lib/apiClient';

const employeeDeploymentService = {
  // Get all deployments
  getDeployments: async (filters = {}) => {
    try {
      const result = await apiClient.get('/employee-deployments', filters);
      return result;
    } catch (error) {
      return { 
        success: false, 
        error: error.message || 'Failed to fetch deployments' 
      };
    }
  },

  // Get deployment by ID
  getDeployment: async (deploymentId) => {
    try {
      const result = await apiClient.get(`/employee-deployments/${deploymentId}`);
      return result;
    } catch (error) {
      return { 
        success: false, 
        error: error.message || 'Failed to fetch deployment details' 
      };
    }
  },

  // Create new deployment
  createDeployment: async (deploymentData) => {
    try {
      const result = await apiClient.post('/employee-deployments', deploymentData);
      return result;
    } catch (error) {
      return { 
        success: false, 
        error: error.message || 'Failed to create deployment' 
      };
    }
  },

  // Update deployment
  updateDeployment: async (deploymentId, deploymentData) => {
    try {
      const result = await apiClient.put(`/employee-deployments/${deploymentId}`, deploymentData);
      return result;
    } catch (error) {
      return { 
        success: false, 
        error: error.message || 'Failed to update deployment' 
      };
    }
  },

  // Delete deployment
  deleteDeployment: async (deploymentId) => {
    try {
      const result = await apiClient.delete(`/employee-deployments/${deploymentId}`);
      return result;
    } catch (error) {
      return { 
        success: false, 
        error: error.message || 'Failed to delete deployment' 
      };
    }
  },

  // Transfer employee deployment
  transferDeployment: async (transferData) => {
    try {
      const result = await apiClient.post('/employee-deployments/transfer', transferData);
      return result;
    } catch (error) {
      return { 
        success: false, 
        error: error.message || 'Failed to transfer deployment' 
      };
    }
  }
};

export default employeeDeploymentService;

